module.exports = __webpack_public_path__ + "fonts/tianhong.4b4303a0.woff2";